import { getDetailedErrorMessage } from "../../../utils/validation";
/**
 * Error thrown when the seller service's ListProposals request fails.
 *
 * `apiError` is intentionally `unknown` — callers hand off whatever axios
 * (or the mock in tests) rejected with, and `getDetailedErrorMessage` is
 * tolerant of any shape. When backend details are available, they are
 * appended in parentheses after the base message rather than replacing it,
 * so consumers always see the human-readable context.
 */
export class ProposalsFetchFailed extends Error {
    constructor(apiError, baseMessage = "Failed to retrieve proposals. Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ProposalsFetchFailed);
        }
        this.name = "ProposalsFetchFailed";
        const detail = getDetailedErrorMessage(apiError, "");
        this.message = detail ? `${baseMessage} (${detail})` : baseMessage;
    }
}
//# sourceMappingURL=errors.js.map